import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { type ReactNode, useEffect, useState } from 'react';

interface Props {
  title: string;
  children: ReactNode;
  hasMatchWithSearchTerm: boolean;
}

export const GlossaryAccordion = ({
  title,
  children,
  hasMatchWithSearchTerm,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(hasMatchWithSearchTerm);
  }, [hasMatchWithSearchTerm]);

  return (
    <Accordion
      expanded={isOpen}
      sx={{
        '&:before': {
          display: 'none',
        },
        '&.Mui-expanded': {
          margin: 0,
          button: {
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0,
          },
        },
      }}
    >
      <AccordionSummary
        onClick={() => setIsOpen(!isOpen)}
        expandIcon={<ExpandMore />}
        sx={{
          backgroundColor: 'background.default',
          border: '1px solid',
          borderColor: 'grey.300',
          borderRadius: '4px',
          typography: 'subtitle2',
          color: 'text.secondary',
          px: 1,
          py: 1.5,
          minHeight: 'unset',
          '&.Mui-expanded': {
            minHeight: 'unset',
          },
          '& .MuiAccordionSummary-content': {
            '&.Mui-expanded': {
              m: 0,
            },
          },
        }}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails
        sx={{
          gap: 2,
          display: 'flex',
          flexDirection: 'column',
          p: 1,
          pt: 1.5,
          border: '1px solid',
          borderColor: 'grey.300',
          borderTop: 'none',
          borderRadius: '0 0 4px 4px',
        }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
};
